import { createReducer } from '@reduxjs/toolkit'
import { Manual } from 'interfaces/api/manuals.interfaces'
import { createBuilder } from 'packages/redux-toolkit'

import { createManual, getBudget, getCondition, getMechanics, getPromo, updateManual } from './actions'

interface ManualTable {
  loading: boolean
  count: number
  items: Manual[]
}

interface ManualsState {
  single: {
    loading: boolean
  }
  promoTable: ManualTable
  budgetTable: ManualTable
  mechanicsTable: ManualTable
  conditionTable: ManualTable
}

const initialState: ManualsState = {
  single: {
    loading: false,
  },
  promoTable: {
    loading: false,
    count: 0,
    items: [],
  },
  budgetTable: {
    loading: false,
    count: 0,
    items: [],
  },
  mechanicsTable: {
    loading: false,
    count: 0,
    items: [],
  },
  conditionTable: {
    loading: false,
    count: 0,
    items: [],
  },
}

export const manualsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getPromo.pending, (state) => {
      state.promoTable.loading = true
    })
    .addCase(getPromo.fulfilled, (state, { payload }) => {
      state.promoTable.items = payload.results
      state.promoTable.count = payload.count
      state.promoTable.loading = false
    })
    .addCase(getPromo.rejected, (state) => {
      state.promoTable.loading = false
    })

    .addCase(getBudget.pending, (state) => {
      state.budgetTable.loading = true
    })
    .addCase(getBudget.fulfilled, (state, { payload }) => {
      state.budgetTable.items = payload.results
      state.budgetTable.count = payload.count
      state.budgetTable.loading = false
    })
    .addCase(getBudget.rejected, (state) => {
      state.budgetTable.loading = false
    })

    .addCase(getMechanics.pending, (state) => {
      state.mechanicsTable.loading = true
    })
    .addCase(getMechanics.fulfilled, (state, { payload }) => {
      state.mechanicsTable.items = payload.results
      state.mechanicsTable.count = payload.count
      state.mechanicsTable.loading = false
    })
    .addCase(getMechanics.rejected, (state) => {
      state.mechanicsTable.loading = false
    })

    .addCase(getCondition.pending, (state) => {
      state.conditionTable.loading = true
    })
    .addCase(getCondition.fulfilled, (state, { payload }) => {
      state.conditionTable.items = payload.results
      state.conditionTable.count = payload.count
      state.conditionTable.loading = false
    })
    .addCase(getCondition.rejected, (state) => {
      state.conditionTable.loading = false
    })

    .addCase([updateManual.pending, createManual.pending], (state) => {
      state.single.loading = true
    })
    .addCase(
      [updateManual.rejected, createManual.rejected, updateManual.fulfilled, createManual.fulfilled],
      (state) => {
        state.single.loading = false
      },
    )
})
